(function () {
    'use strict';

    angular
        .module('skillsApp')
        .factory('userService', userService);

    function userService($http, $q, $log, config, baseUrl, portalUrl, portalIdentifier, tokenService) {

        var _cache = {};

        return {
            getUser: getUser,
            getDomains: getDomains,
            searchIdentities: searchIdentities
        };

        function getDomains(cache = false) {
            if (cache && _cache.expires !== undefined && _cache.expires > Date.now()) {
                return $q.resolve(_cache.domains);
            }
            
            return tokenService.getToken()
                .then(() => $http.get('https://sso.competence.biz/login/api/1.0/domains', { cache: true }))
                .then(response => _.sortBy(response.data, x => x.displayName.toLowerCase()), errorResponse => $q.reject(errorResponse.data))
                .then(domains => {

                    var userDomainId = config.settings.user.idString.substring(2, 38);
                    var loginDomains = _.union(config.settings.loginDomains, [userDomainId, "d86c54f6-6d65-47b5-a647-a6b6a758c545", "6e74b84e-0422-4675-8993-bde186c655b3"]);
                    domains = _.filter(domains, function (domain) { return _.contains(loginDomains, domain.id); });
                    domains.forEach(d => d.identityPrefix = "//" + d.id + "//");

                    var now = new Date();
                    _cache.domains = domains;
                    _cache.expires = now.setMinutes(now.getMinutes() + 60);
                    
                    return $q.resolve(domains);
                });
        }

        function getUser() {
            return tokenService.getToken()
                .then(function () {
                    return $http.get(portalUrl + '/api/1.0/user')
                        .then(function (response) {
                            return response.data;
                        }, function (response) {
                            return $q.reject(response.data);
                        });
                });
        }

        function searchIdentities(search, type, userStatus) {
            var req = {
                url: baseUrl + '/api/6.0/search/sso',
                method: 'GET',
                params: {
                    search: search,
                    type: type,
                    userStatus: userStatus
                }
            };

            return tokenService.getToken()
                .then(() => {
                    return $http(req).then(response => {

                        var domainUsers = _.find(response.data, item => { return item.id === undefined; });
                        var results = _.chain(response.data)
                            .without(domainUsers)
                            .sortBy(user => { return user.displayName.toLowerCase(); })
                            .map(item => {
                                return {
                                    displayName: item.displayName,
                                    idString: item.idString,
                                    isUser: item.isUser,
                                    username: item.username,
                                    isDisabled: item.isDisabled
                                };
                            })
                            .value();

                        if (domainUsers) {
                            results.unshift(domainUsers);
                        }

                        return results;
                    });
                });
        }
    }
})();
